import { useResetRecoilState, useSetRecoilState } from 'recoil';
import { documentsInitialState, documentsReloadTrigger } from '../api/documents/documents';
import { deliveryNotesInitialState, deliveryNotesReloadTrigger } from '../api/deliveryNotes/deliveryNotes';
import { creditNotesInitialState, creditNotesReloadTrigger } from '../api/creditNotes/creditNotes';
import { invoicesInitialState, invoicesReloadTrigger } from '../api/invoices/invoices';
import { useResetAllProductDetails } from '../api/products/productDetail';
import { ordersInitialState, ordersReloadTrigger } from '../api/orders/orders';
import { shoppingListsListQueryReloadTrigger } from '../api/shoppingLists';
import { favoriteProductIdsState } from '../api/products/favoriteProducts';
import { cartsReloadTrigger } from '../api/cart/cart';
import { productVariantsReloadTrigger } from '../api/products/catalogue';
import { shoppingSelectedDeliveryPlaceState } from '../api/shopping';
import { productTaxonomyTypesReloadTrigger } from '../api/products/taxonomyTypes';
import { productTaxonomyLoyaltyProgramTypesReloadTrigger } from '../api/products/taxonomyTypesLoyaltyProgram';
import { summerPromoInitialState, summerPromoReloadTrigger } from '../api/appState';

const useResetRecoil = (): (() => void) => {
  const resetDocumentsInitialState = useResetRecoilState(documentsInitialState);
  const resetDeliveryNotesInitialState = useResetRecoilState(deliveryNotesInitialState);
  const resetCreditNotesInitialState = useResetRecoilState(creditNotesInitialState);
  const resetInvoicesInitialState = useResetRecoilState(invoicesInitialState);
  const resetProductDetailInitialStateFamily = useResetAllProductDetails();
  const resetSummerPromoInitialState = useResetRecoilState(summerPromoInitialState);

  // const resetInvoicesAndCreditNotesInitialState = useResetRecoilState(invoicesAndCreditNotesInitialState);
  const resetOrdersInitialState = useResetRecoilState(ordersInitialState);
  const resetFavoriteProductIdsState = useResetRecoilState(favoriteProductIdsState);

  const setDocumentsReloadTrigger = useSetRecoilState(documentsReloadTrigger);
  const setDeliveryNotesReloadTrigger = useSetRecoilState(deliveryNotesReloadTrigger);
  const setCreditNotesReloadTrigger = useSetRecoilState(creditNotesReloadTrigger);
  const setInvoicesReloadTrigger = useSetRecoilState(invoicesReloadTrigger);
  const setProductTaxonomyTypesReloadTrigger = useSetRecoilState(productTaxonomyTypesReloadTrigger);
  const setProductTaxonomyLoyaltyProgramTypesReloadTrigger = useSetRecoilState(productTaxonomyLoyaltyProgramTypesReloadTrigger);
  // const setInvoicesAndCreditNotesReloadTrigger = useSetRecoilState(InvoicesAndCreditNotesReloadTrigger);
  const setCartsReloadTrigger = useSetRecoilState(cartsReloadTrigger);
  const setOrdersReloadTrigger = useSetRecoilState(ordersReloadTrigger);
  const resetShoppingSelectedDeliveryPlaceState = useSetRecoilState(shoppingSelectedDeliveryPlaceState);
  const setShoppingListsListQueryReloadTrigger = useSetRecoilState(shoppingListsListQueryReloadTrigger);
  const setProductVariantsReloadTrigger = useSetRecoilState(productVariantsReloadTrigger);
  const setSummerPromoReloadTrigger = useSetRecoilState(summerPromoReloadTrigger);

  return () => {
    resetProductDetailInitialStateFamily();
    resetDocumentsInitialState();
    resetDeliveryNotesInitialState();
    resetCreditNotesInitialState();
    resetInvoicesInitialState();
    // resetInvoicesAndCreditNotesInitialState();
    resetFavoriteProductIdsState();
    resetOrdersInitialState();
    resetShoppingSelectedDeliveryPlaceState(undefined);
    resetSummerPromoInitialState();

    setDocumentsReloadTrigger((n) => n + 1);
    setDeliveryNotesReloadTrigger((n) => n + 1);
    setCartsReloadTrigger((n) => n + 1);
    setCreditNotesReloadTrigger((n) => n + 1);
    setInvoicesReloadTrigger((n) => n + 1);
    setProductTaxonomyTypesReloadTrigger((n) => n + 1);
    setProductTaxonomyLoyaltyProgramTypesReloadTrigger((n) => n + 1);
    // setInvoicesAndCreditNotesReloadTrigger((n) => n + 1);
    setOrdersReloadTrigger((n) => n + 1);
    setShoppingListsListQueryReloadTrigger((n) => n + 1);
    setProductVariantsReloadTrigger((n) => n + 1);
    setSummerPromoReloadTrigger((n) => n + 1);
  };
};

export default useResetRecoil;
